"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var heartbeatAnimation = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  to {\n    stroke-dashoffset: 0;\n  }\n"], ["\n  to {\n    stroke-dashoffset: 0;\n  }\n"])));
var circleAnimation = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  25% {\n    stroke-dashoffset: 283;\n    transform: rotate(-90deg);\n  }\n  50%,\n  75% {\n    stroke-dashoffset: 0;\n    transform: rotate(-90deg);\n  }\n\n  100% {\n    stroke-dashoffset: 283;\n    transform: rotate(270deg)\n  }\n"], ["\n  25% {\n    stroke-dashoffset: 283;\n    transform: rotate(-90deg);\n  }\n  50%,\n  75% {\n    stroke-dashoffset: 0;\n    transform: rotate(-90deg);\n  }\n\n  100% {\n    stroke-dashoffset: 283;\n    transform: rotate(270deg)\n  }\n"])));
var StyledSvg = styled_components_1["default"].svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  width: ", ";\n  height: ", ";\n  margin: auto;\n"], ["\n  display: block;\n  width: ", ";\n  height: ", ";\n  margin: auto;\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
});
var StyledPath = styled_components_1["default"].path(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  animation: 2.5s ", " infinite ", ";\n  animation-delay: ", "s;\n  fill: transparent;\n  stroke: ", ";\n  stroke-linejoin: round;\n  stroke-width: ", "px;\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n"], ["\n  animation: 2.5s ", " infinite ", ";\n  animation-delay: ", "s;\n  fill: transparent;\n  stroke: ",
    ";\n  stroke-linejoin: round;\n  stroke-width: ", "px;\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n"])), function (_a) {
    var animation = _a.animation;
    return animation;
}, heartbeatAnimation, function (_a) {
    var _b = _a.delay, delay = _b === void 0 ? 1 : _b;
    return delay;
}, function (_a) {
    var strokeColor = _a.strokeColor, theme = _a.theme;
    return theme.colors[strokeColor] || strokeColor;
}, function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 4 : _b;
    return strokeWidth;
});
var StyledCircle = styled_components_1["default"].circle(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  animation: 2.5s ease-in infinite ", ";\n  animation-delay: ", "s;\n  fill: transparent;\n  stroke: ", ";\n  stroke-dasharray: 283;\n  stroke-dashoffset: 283;\n  stroke-width: 5px;\n  transform-origin: 50% 50%;\n  transform: rotate(-90deg);\n  ", "\n"], ["\n  animation: 2.5s ease-in infinite ", ";\n  animation-delay: ", "s;\n  fill: transparent;\n  stroke: ",
    ";\n  stroke-dasharray: 283;\n  stroke-dashoffset: 283;\n  stroke-width: 5px;\n  transform-origin: 50% 50%;\n  transform: rotate(-90deg);\n  ", "\n"])), circleAnimation, function (_a) {
    var _b = _a.delay, delay = _b === void 0 ? 0 : _b;
    return delay;
}, function (_a) {
    var strokeColor = _a.strokeColor, theme = _a.theme;
    return theme.colors[strokeColor] || strokeColor;
}, function (_a) {
    var isOpacity = _a.isOpacity;
    return isOpacity && 'opacity:0.5;';
});
var LoadingIcon = function (_a) {
    var width = _a.width, height = _a.height, color = _a.color, backgroundColor = _a.backgroundColor;
    return (react_1["default"].createElement(StyledSvg, { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", width: width, height: height },
        react_1["default"].createElement(StyledPath, { d: "M95,50 L72.5,50 L61.25,27.5 L38.75,72.5 L27.5,50 L5,50", animation: "ease", strokeColor: color }),
        react_1["default"].createElement(StyledPath, { d: "M95,50 L72.5,50 L61.25,27.5 L38.75,72.5 L27.5,50 L5,50", animation: "ease-in-out", delay: 1.2, strokeWidth: 6, strokeColor: backgroundColor }),
        react_1["default"].createElement(StyledCircle, { cx: "50", cy: "50", r: "45", strokeColor: color }),
        react_1["default"].createElement(StyledCircle, { cx: "50", cy: "50", r: "45", delay: 0.1, strokeColor: color, isOpacity: true })));
};
LoadingIcon.defaultProps = {
    width: '100%',
    height: '100%',
    color: 'primaryText',
    backgroundColor: 'primary'
};
exports["default"] = LoadingIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=LoadingIcon.js.map